<template>
    <div :data-testid="dataTestid" class="freelancer-signup-step-welcome-to-malt__article">
        <slot name="article-icon" />
        <div>
            <div :data-testid="`${props.dataTestid}--title`" class="freelancer-signup-step-welcome-to-malt__article__title">
                <slot name="article-title" />
            </div>
            <div :data-testid="`${props.dataTestid}--content`" class="freelancer-signup-step-welcome-to-malt__article__content">
                <slot name="article-content" />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    type FreelancerSignupArticleProps = {
        dataTestid?: string;
    };

    const props = withDefaults(defineProps<FreelancerSignupArticleProps>(), {
        dataTestid: 'freelancer-signup-article',
    });
</script>
<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .freelancer-signup-step-welcome-to-malt {
        &__article {
            display: flex;
            flex-direction: row;
            gap: var(--joy-core-spacing-2);
            padding-top: var(--joy-core-spacing-8);

            &__title {
                @include text.getFontBySize(primary-650);

                margin-bottom: var(--joy-core-spacing-2);
            }

            .profile-common__icon-counter {
                position: relative;
                top: -8px;
            }
        }
    }
</style>
